import { FormAction, GlobalState } from "./types";
import { GlobalStateDataTypes } from "./actions";

export const initialGlobalState: GlobalState = {
    formAlias: null,
    mrmEnvironment: 'production',
    debug: false,
    pageId: 0,
    locale: 'sv-SE'
};

export function globalStateReducer(state: GlobalState, action: FormAction): GlobalState {
    switch (action.type) {
        case GlobalStateDataTypes.SetFormAlias:
            return {
                ...state,
                formAlias: action.payload.alias
            }
        case GlobalStateDataTypes.SetMrmEnvironment:
            return {
                ...state,
                mrmEnvironment: action.payload.environment
            }
        case GlobalStateDataTypes.SetDebug:
            return {
                ...state,
                debug: action.payload.flag
            }
        case GlobalStateDataTypes.SetPageId:
            return {
                ...state,
                pageId: action.payload.id
            }
        case GlobalStateDataTypes.SetLocale:
            return {
                ...state,
                locale: action.payload.locale
            }
            case GlobalStateDataTypes.SetState:
                return {
                    ...state,
                    ...action.payload.state
                }
        default:
            return state;
    }
}